// ==================================
// Servicio de Dashboard
// ==================================

import api from './api';
import type { DashboardStats, ApiResponse } from '@/tipos';

export const dashboardServicio = {
  obtenerEstadisticas: async (): Promise<DashboardStats> => {
    const response = await api.get<ApiResponse<DashboardStats>>('/admin/tablero');
    return response.data.data;
  },
};

export default dashboardServicio;
